module.exports = {
  // JCRing成员页
  JCRing_member: {
    //首页
    index1: "Insieme in salute",
    index2: "Gruppo Salute",
    indice3: "membro",
    index4: "Creare un nuovo gruppo",
    index5: "Il mio gruppo",
    index6: "Impostazioni di avviso",
    index7: "Prenditi cura della salute dei tuoi cari",
    index8: "Nessun gruppo",
    index9: "Membri",
    index10:
      "Invita a partecipare tramite cellulare/email/codice QR o WhattsApp",

    //创建群组
    addgroup1: "Nome del gruppo",
    addgroup2: "Tipo di gruppo",
    addgroup3: "Inserire",
    addgroup4: "Gruppo familiare",
    addgroup5: "Gruppo aziendale",
    addgroup6: "Altro gruppo",
    addgroup7: "Gruppo ospedaliero",
    addgroup8: "Gruppo scolastico",
    addgroup9: "Sì",
    addgroup10: "No",
    addgroup11: "Crea un nuovo gruppo",
    addgroup12: "Il nome del gruppo esiste già",

    //成员列表
    memberlist1: "Elenco membri",
    memberlist2: "avere",
    memberlist3: "Anomalie",
    memberlist4: "Normale",
    memberlist5: "Aggiungi un membro",
    memberlist6: "Elimina",
    memberlist7: "Nessun membro",
    memberlist8: "caricamento...",
    memberlist9: "Sei sicuro di voler cancellare il gruppo?",
    memberlist10: "Cancellato con successo",
    memberlist11: "Salvato con successo",
    memberlist12: "Modifica",
    memberlist13: "Rifiuta",
    memberlist14: "Statistiche sanitarie",
    memberlist15: "Normale",
    memberlist16: "Anormale",
    memberlist17: "ulteriori dettagli",
    memberlist18: "Nessun dato per ieri",
    memberlist19: "ieri",
    memberlist20: "Invita semplicemente",
    memberlist21: "confermare per unirsi al gruppoxxx!",

    //4FEE↩改成员
    updatemember1: "Profilo",
    updatemember2: "Cambiare",
    updatemember3: "Nickname recente",
    updatemember4: "Cambia nickname",

    //健康数据
    healthdata1: "Salute",
    healthdata2: "Dati sanitari",
    healthdata3: "Dom",
    healthdata4: "Lun",
    healthdata5: "Mar",
    healthdata6: "Mer",
    healthdata7: "Gio",
    healthdata8: "Ven",
    healthdata9: "Sab",
    healthdata10: "Frequenza cardiaca",
    healthdata11: "HRV",
    healthdata12: "Sistolica",
    healthdata13: "Diastolica",
    healthdata14: "Temperatura corporea",
    healthdata15: "SpO2",
    healthdata16: "Sonno",
    healthdata17: "Stress",
    healthdata18: "Colesterolo",
    healthdata19: "Trigliceridi",
    healthdata20: "LDL-C",
    healthdata21: "HDL-C",
    healthdata22: "Glicemia",
    healthdata23: "Prima del pasto",
    healthdata24: "Dopo il pasto",
    healthdata25: "VO2 Max",
    healthdata26: "Apparato respiratorio",
    healthdata27: "Passi",
    healthdata28: "Passi",
    healthdata29: "Calorie",
    healthdata30: "kcal",
    healthdata31: "Distanza",
    healthdata32: "km",
    healthdata33: "Tempo",
    healthdata35: "″/KM",
    healthdata36: "′",
    healthdata37: "Generare un rapporto sulla salute",
    healthdata38: "Dati di attività",
    healthdata39: "Attenzione",
    healthdata40: "Non autorizzato",
    healthdata41: "Modifica",
    healthdata42: "Cancellare",
    healthdata43: "E-Mail: ",
    healthdata44: "Telefono: ",
    healthdata45: "Confermare la cancellazione?",
    healthdata46: "I dati futuri non possono essere visualizzati",
    healthdata47: "Oggi",

    //邀请成员
    addmember1: "Invita Membro",
    addmember2: "Aggiungi Account Membro",
    addmember4:
      "Attraverso l' 'Account Membro', puoi visualizzare i dati sulla salute dei membri e impostare intervalli di dati di allarme per monitorare meglio la salute dei membri",
    addmember5: "Ulteriori informazioni",
    addmember6: "Membri del Gruppo Salute",
    addmember7: "Invitare",
    addmember8: "Unirsi",
    addmember9: "Invita tramite QR Code",
    addmember10: "Invita tramite WeChat",
    addmember11: "Invita a unirsi al gruppo tramite QR Code",
    addmember12: "Invita a unirsi al gruppo tramite WeChat",
    addmember13: "Invita tramite numero di telefono/e-mail",
    addmember14: "Invita a unirsi al gruppo tramite numero di telefono/e-mail",
    addmember15:
      "Invita i membri a unirsi per comprendere il loro stato di salute",
    addmember16: "Invia invito",
    addmember17: "Inviato",
    addmember18: "In attesa di conferma",
    addmember19: "Ho aderito",
    addmember20: "Condividi ora",
    addmember21: "Salva immagine",
    addmember22: "Ho rifiutato",
    addmember23: "Ho lasciato",
    addmember24: "L'altra parte ha lasciato",
    addmember25: "L'altra parte ha rifiutato",
    addmember26: "L'altra parte ha aderito",
    addmember27: "Altri metodi di aggiunta",

    // 群组二维码
    code1: "Codice QR del gruppo",
    codice2: "Insieme in salute",
    code3: "Il codice QR è valido 5 minuti, si prega di scansionarlo in tempo",

    //群组邀请
    invide1: "Invito di gruppo",
    invide2: "Salute dei membri",
    invide3: "Sei invitato a unirti al gruppo, per favore conferma!",
    invide4: "Unirsi al gruppo？",
    invide5:
      "Per la sicurezza die tuoi dati, controlla le informazioni del gruppo prima di unirti al gruppo",
    invide6:
      "Dopo aver aderito al gruppo, è possibile autorizzare il rispettivo membro a visualizzare i propri dati sanitari",

    //分享健康数渶设置
    sethealthdata1: "Impostazione dei dati sanitari",
    sethealthdata2: "Conferma",
    sethealthdata3: "Si prega di impostare un soprannome",
    sethealthdata4: "Consenti tutto",
    sethealthdata5: "Imposta il soprannome",
    sethealthdata6: "Salva",
    sethealthdata7: "Si prega di inserire",
    sethealthdata8: "Si prega di caricare il formato dell'immagine",
    sethealthdata9: "Si prega di impostare un soprannome e un avatar",
    sethealthdata10: "Si prega di impostare un avatar",
    sethealthdata11: "La lunghezza del soprannome è di 1-8 caratteri",

    // 设置数据区间
    setscope1: "Allarme frequenza cardiaca",
    setscope2: "Allarme temperatura corporea",
    setscope3: "Allarme sonno",
    setscope4: "Frequenza cardiaca fetale",
    setscope5: "Glicemia a digiuno",
    setscope6: "Valori della glicemia postprandiale",
    setscope7: "Allarme SpO2",
    setscope8: "Acido urico maschile",
    setscope9: "Acido urico femminile",
    setscope10: "Sistolica",
    setscope11: "Diastolica",
    setscope12: "Alto",
    setscope13: "Basso",
    setscope14: "Impostazione dell'allarme",
    setscope15: "Impostazione riuscita",
    setscope16: "Troppo",
    setscope17: "Troppo poco",
    setscope18: "Allarme",

    //下载页
    onload1: "Click",
    onload2: "Unirsi al gruppo",
    onload3: "Aprire con il browser",
    onload4: "Conferma",
    onload5: "Godersi la salute ogni giorno",
    onload6: "Download gratuito dall'App Store",
    onload7: "Download gratuito su App Store",
    onload8: "Il link è scaduto",
    onload9: "Il codice QR è scaduto",
    onload10: "Adesione riuscita",

    // 待处理
    pending1: "Accettare",
    pending2: "Rifiutare",
    pending3: "Invia nuovamente l'invito",
    pending4: "Nessun dato",
    pending5: "Invito già inviato, attendere conferma",
    pending6: "OK",
    pending7: "exit",

    guide1: "Creare un gruppo sanitario e dargli un nome",
    guida2:
      "È possibile controllare i dati sulla salute dei membri del gruppo e invitare nuovi membri a unirsi a questo gruppo sanitario",
    guida3:
      "È possibile invitare nuovi membri tramite scansione del codice QR, WhattsApp, telefono cellulare o e-mail. Non appena il nuovo membro si unisce al gruppo, è possibile controllare i suoi dati sanitari",
    guida4:
      "È possibile controllare lo stato di salute dei membri del gruppo e vedere i loro dati anomali",
    guida5: "Avanti",
    guida6: "OK",
    guida7: "Avviso di sovraccarico",

    invito1: "Insieme via cellulare/email",
    invite2: "Si prega di inserire l'account",
    invite3: "Si prega di inserire il numero di telefono",
    invite4: "Si prega di inserire l'email",
    invito5: "Inserire il numero di telefono corretto",
    invito6: "Inserire l'e-mail corretta",
    invito7: "Ho già aderito al gruppo",
    invite8: "L'utente non esiste",
    invite9: "Si prega di selezionare il paese o la regione",
    invite10: "Si prega di inserire la parola chiave di ricerca",
    invite11: "Conferma utente",
    invite12: "Invita loro",
    invite13: "Si prega di selezionare"
  }
};



// WEBPACK FOOTER //
// ./src/lang/it.js